import { LinkAuthMethodStrategy } from './link-auth-method-strategy.inteface';
import { AuthMethod } from '../../../account-window/parts/auth-method';
import { HubApi } from '@scorewarrior/rubens_web_lib/lib/hub-api/hub-api';
import {
    LinkAuthMethodEmailRequest,
    LinkAuthMethodEmailResponse
} from '@scorewarrior/rubens_web_lib/lib/hub-api/protocol/link-auth-method-email.protocol';

export class LinkAuthMethodEmailStrategy implements LinkAuthMethodStrategy {
    static authMethod = AuthMethod.EMAIL;
    constructor(private hubApi: HubApi) {}

    link(deviceId: string, params: LinkAuthMethodEmailRequest): Promise<LinkAuthMethodEmailResponse> {
        return this.hubApi.linkAuthMethodEmail(deviceId, params);
    }
}
